export const PAGE_SIZE = 20;
export const MAX_SIZE = 10;
export const CURRENCY_SYB = {
  Euro: 'Euro : €',
  US_Dollar: 'US Dollars : $',
  British_Pounds: 'British Pounds : £',
};

export const CURRENCY_SYMBOL = {
  Euro: '€',
  US_Dollar: '$',
  British_Pounds: '£',
};
